export const environment = {
  production: true,
  mediaUrl: 'https://sam-api-dev.zetra.it/nes',
  baseUrl: 'https://sam-api-dev.zetra.it',
  basePDFServiceUrl: 'https://sam-dev.pdf-service.zetra.it',
  baseExcelServiceUrl: 'https://sam-dev.xlsreport-service.zetra.it',
  baseMailerServiceUrl: 'https://sam-dev.email-service.zetra.it',
  version: '1.2.4',
  softwareName: 'SAM',
};
